export const ethinic = [
  { value: 'Asian', text: 'Asian' },
  { value: 'BlackAfrican', text: 'Black/African' },
  { value: 'Caucasian', text: 'Caucasian' },
  { value: 'HispanicLatinx', text: 'Hispanic/Latinx' },
  { value: 'NativeAmerican', text: 'Native American' },
  { value: 'Pacific Islander', text: 'Pacific Islander' },  
  { value: 'OtherEthinicity', text: 'Other' }
]

export const ETHINIC = ethinic.map(item => {
  item.group = 'ethinic'
  return item
})
